<form [formGroup]="form">
  <app-picklist [formControl]="form.controls['selectedBatches']"
                [source]="availableBatches"
                formControlName="selectedBatches"
                [sourceHeader]=sourceHeader
                [targetHeader]=targetHeader>
  </app-picklist>
</form>